import type { Resource } from '../../';
export const search_box_frame_keepSearching: Resource = {"default":"Keep Shopping For"};
